module.exports = __webpack_public_path__ + "/hashedassets-launcher/v3/school_connection_desktop_banner.1870a2b22875f34d97b2e7519257ca02.png";